import FormSection from './FormSection.jsx';
import { ArrowRightIcon } from '@heroicons/react/24/outline/index.js';
import React from 'react';

const FormViewSections = ({
    sections,
    submit,
    formData,
    setFormData,
    showNextSection,
    submitError,
    setSubmitError,
    isSubmitting,
    hasPaymentStep,
    submitIsNext,
    hasEvents,
    visibleSections,
    styles,
}) => {
    return (
        <form onSubmit={submit} className="form-section-container">
            {sections.map(sectionData => (
                <div
                    key={sectionData.section.id}
                    data-sectionid={sectionData.section.id}
                    className={
                        'form-section ' +
                        (visibleSections.indexOf(sectionData.section.id) > -1
                            ? 'form-section-visible'
                            : 'form-section-hidden') +
                        (visibleSections.indexOf(sectionData.section.id) ===
                        visibleSections.length - 1
                            ? ' form-section-current'
                            : '')
                    }
                >
                    <FormSection
                        section={sectionData.section}
                        questions={sectionData.questions}
                        formData={formData}
                        setFormData={(id, value) => {
                            setFormData(old => {
                                let newValue = value;
                                if (typeof value === 'function') {
                                    newValue = value(old[id]);
                                }

                                return {
                                    ...old,
                                    [id]: newValue,
                                };
                            });
                        }}
                    />
                </div>
            ))}
            {!styles?.hideSubmit && (
                <div className="">
                    {!submitIsNext && (
                        <button
                            className="flex items-center justify-between form-button"
                            type="button"
                            onClick={showNextSection}
                        >
                            <span className="">Next</span>
                            <ArrowRightIcon className="w-4 h-4 ml-2" />
                        </button>
                    )}
                    {submitIsNext && (
                        <>
                            {!!submitError && (
                                <div className="text-red-600 mb-2 text-base font-medium">
                                    {submitError}
                                </div>
                            )}
                            <button
                                className="min-w-32 form-button"
                                type="submit"
                            >
                                {isSubmitting
                                    ? 'Submitting...'
                                    : hasPaymentStep
                                      ? 'Pay'
                                      : hasEvents
                                        ? 'Confirm'
                                        : 'Submit'}
                            </button>
                        </>
                    )}
                </div>
            )}
        </form>
    );
};

export default FormViewSections;
